import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";

import Login from "../auth/login/login";
import TwoStepVerification2 from "../auth/twoStepVerification/twoStepVerification-2";
import SuperAdminDashboard from "../super-admin/dashboard";
import Companies from "../super-admin/companies";
import Subscription from "../super-admin/subscription";
import Packages from "../super-admin/packages/packagelist";
import EmployeeList from "../hrm/employees/employeesList";
import EmployeesGrid from "../hrm/employees/employeesGrid";
import EmployeeDetails from "../hrm/employees/employeedetails";
import Department from "../hrm/employees/deparment";
import Designations from "../hrm/employees/designations";
import Policy from "../hrm/employees/policy";
import ContactList from "../crm/contacts/contactList";
import ContactGrid from "../crm/contacts/contactGrid";
import ContactDetails from "../crm/contacts/contactDetails";
import CompaniesGrid from "../crm/companies/companiesGrid";
import CompaniesList from "../crm/companies/companiesList";
import CompaniesDetails from "../crm/companies/companiesDetails";
import LeadsGrid from "../crm/leads/leadsGrid";
import LeadsFormList from "../crm/leads/leadsFormList";
import LeadsList from "../crm/leads/leadsList";
import LeadsTransfer from "../crm/leads/leadsTransfer";
import DealsTransfer from "../crm/deals/dealsTransfer";
import LeadsDetails from "../crm/leads/leadsDetails";
import DealsGrid from "../crm/deals/dealsGrid";
import DealsList from "../crm/deals/dealsList";
import DealsDetails from "../crm/deals/dealsDetails";
import Pipeline from "../crm/pipeline/pipeline";
import Analytics from "../crm/analytics/analytics";
import LeadsDasboard from "../mainMenu/leadsDashboard";
import DealsDashboard from "../mainMenu/dealsDashboard";
import CrmSettings from "../crm/settings/crm-settings";
import LiveCalls from "../crm/liveCall/LiveCallPage";
import LeadsCall from "../crm/liveCall/LeadsCallPage";
import CallLogs from "../crm/callLogs/call-logs";
import AssignAsset from "../administration/assign-asset";
import AssetsCategory from "../administration/asset-category";
import AssetsProduct from "../administration/asset-product";
import AssetsStock from "../administration/asset-stock";
import LeadsQueue from "../crm/leads/leadQueue";
import LeadBankPage from "../crm/leads/leadBankPage";
import LeadsHistoryPage from "../crm/leads/LeadsHistoryPage";
import ProjectShell from "../projects/project/components/ProjectShell";
import ProjectsList from "../projects/projects-list/pages/ProjectsList";
import ProjectOverview from "../projects/project/pages/ProjectOverview";
import ProjectReports from "../projects/project/pages/ProjectReports";
import BoardPage from "../projects/board/pages/BoardPage";
import BacklogPage from "../projects/backlog/pages/BacklogPage";
import IssuesList from "../projects/issues/pages/IssuesList";
import IssueDetails from "../projects/issues/pages/IssueDetails";
import DetailsSettings from "../projects/settings/pages/DetailsSettings";
import MembersSettings from "../projects/settings/pages/MembersSettings";
import BoardSettings from "../projects/settings/pages/BoardSettings";
import LabelsSettings from "../projects/settings/pages/LabelsSettings";
import CustomFieldsSettings from "../projects/settings/pages/CustomFieldsSettings";
import ComponentsSettings from "../projects/settings/pages/ComponentsSettings";
import VersionsSettings from "../projects/settings/pages/VersionsSettings";
import ResolutionsSettings from "../projects/settings/pages/ResolutionsSettings";
import GanttPage from "../projects/gantt/pages/GanttPage";
import Tickets from "../tickets/tickets";
import AttendanceAdmin from "../hrm/attendance/admin/pages/AttendanceAdminPage";
import PayrollReportPage from "../hrm/attendance/payroll/pages/PayrollReportPage";
import LeaveReport from "../administration/reports/leavereport";
import AttendanceReport from "../administration/reports/attendencereport";
import LeaveAdmin from "../hrm/attendance/leaves/admin/pages/LeaveAdminPage";
import LeaveSummaryPage from "../hrm/attendance/leaves/admin/components/LeaveSummaryPage";
import LeaveEmployee from "../hrm/attendance/leaves/employee/pages/LeaveEmployeePage";
import LeaveSettings from "../hrm/attendance/leaves/settings/pages/LeaveSettingsPage";
import AdjustmentLogPage from "../hrm/attendance/leaves/admin/pages/AdjustmentLogPage";
import AttendanceEmployee from "../hrm/attendance/employee/pages/AttendanceEmployeePage";
import TimeSheet from "../hrm/attendance/settings/pages/TimesheetPage";
import ScheduleTiming from "../hrm/attendance/settings/pages/ScheduleTimingPage";
import OverTime from "../hrm/attendance/settings/pages/OvertimePage";
import Settings from "../hrm/attendance/settings/pages/AttendanceSettingsPage";
import TicketCategory from "../tickets/ticket-category";
import FileManager from "../application/fileManager";
import AccesFile from "../application/accesFile";
import CMSLeadDashboard from "../mainMenu/cmsLeadDashboard";
import CMSDealDashboard from "../mainMenu/cmsDealDashboard";
import TodoPage from "../application/todo";
import Chat from "../application/chat";
import BulkUpload from "../crm/callLogs/bulkUpload";
import Dashboard from "../recruitment/applications/pages/ApplicationsManagement";
import Unauthorized from "../otherPgaes/Unauthorized";
import EmailSelect from "../application/email/emailSelect";
import Configuration from "../configurations/configuration";
import Fonada from "../configurations/whatsapp/fonada/fonada";
import WhatsappConfigDetailPage from "../configurations/whatsapp/whatsappConfigDetailPage";
import AssetsLocation from "../administration/asset-location";
import AdminDashboard from "../mainMenu/adminDashboard";
import CandidateListView from "../recruitment/applications/pages/CandidateListView";
import CandidateGridView from "../recruitment/applications/pages/CandidateGridView";
import CandidateKanbanView from "../recruitment/applications/pages/CandidateKanbanView";
import ThankYouPage from "../recruitment/applications/pages/ThankYouPage";
import OrganizationChart from "../../core/common/organization-chart/OrganizationChar";

//ERS - Reports
import MyReports from "../ers/reports/overview";
import CreateReport from "../ers/reports/create-report";
import EditReport from "../ers/reports/edit-report";

//ERS - Team Reports
import TeamReports from "../ers/team-reports/overview";

//ERS - Report Setting
import ReportType from "../ers/reports-settings/report-type";
import ActivityCalendar from "../application/activityCalendar/activityCalendar";
import MoodMeterDashboard from "../application/MoodMeter/MoodMeterDashboard";
import FacebookLeadsConfig from "../crm/leads/FacebookLeadsConfig";

// AUTOMATION
import AutomationCreate from "../automations/shared/components/AutomationCreate";
import AutomationEdit from "../automations/shared/components/AutomationEdit";
import ExecutionHistory from "../automations/shared/components/ExecutionHistory";
import AssetsAutomation from "../automations/modules/AssetsAutomation";
import LeadsAutomation from "../automations/modules/LeadsAutomation";
import AttendanceAutomation from "../automations/modules/AttendanceAutomation";
import DealsAutomation from "../automations/modules/DealsAutomation";
import TaskManagerAutomation from "../automations/modules/TaskManagerAutomation";
import CalendarAutomation from "../automations/modules/CalendarAutomation";
import EmployeeReportingAutomation from "../automations/modules/EmployeeReportingAutomation";
import TicketsAutomation from "../automations/modules/TicketsAutomation";
import AssignedTickets from "../tickets/ticket-assigned";

// Public ADD Lead forms
import PublicLeadForm from "../crm/leads/share-leads/index";
import WhatsAppChatsViewer from "../crm/leads/WhatsAppChatsViewer";
import WhatsAppAccounts from "../crm/leads/WhatsAppAccount";
import WebhookIntegrationsPage from "../crm/webhook-integrations/WebhookIntegrationsPage";

// Whatsapp Configurations
import WhatsappConfig from "../configurations/whatsapp-config/index";
import EmailTemplatesPage from "../configurations/email-templates/index";
import EmailTemplateEditorPage from "../configurations/email-templates/components/EmailTemplateEditorPage";
import ConfigTemplatesPage from "../configurations/whatsapp-config/components/ConfigTemplatesPage";
import ConfigTemplateMessageLogsPage from "../configurations/whatsapp-config/components/ConfigTemplateMessageLogsPage";
import HolidayUpload from "../application/activityCalendar/HolidayUpload";
import AnalyticsDashboard from "../mainMenu/analyticsDashboard";
import MoodQuestionsPage from "../application/MoodMeter/MoodQuestionsPage";
import MoodQuestionnairePage from "../application/MoodMeter/MoodQuestionnairePage";

// Recruitment
import EmployeeUserCall from "../crm/callLogs/employeeUserCall";
import HiringSettings from "../recruitment/settings/index";
import InterviewList from "../recruitment/interviews/index";
import CandidateDetails from "../recruitment/applications/pages/CandidateDetails";
import CandidateUploadPortal from "../recruitment/public/pages/CandidateUploadPortal";
import JobGrid from "../recruitment/jobs/index";
import JobDetails from "../recruitment/jobs/pages/JobDetails";
import RefferalList from "../recruitment/referrals/index";
import EmployeeReferrals from "../recruitment/referrals/EmployeeReferrals";
import RecruitmentCandidatesList from "../recruitment/candidates/pages/CandidatesList";
import RecruitmentCandidateView from "../recruitment/candidates/pages/CandidateView";

// Public Recruitment
import CareerPage from "../recruitment/public/pages/CareerPage";
import JobDetailsApply from "../recruitment/public/pages/JobDetailsApply";
import ApplicationTracking from "../recruitment/public/pages/ApplicationTracking";
import CandidateDashboard from "../recruitment/public/pages/CandidateDashboard";
import PublicFeedbackForm from "../recruitment/public/pages/PublicFeedbackForm";
import PublicSelfScheduling from "../recruitment/public/pages/PublicSelfScheduling";

const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/login" />,
    route: Route,
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.analyticsDashboard,
    element: <AnalyticsDashboard />,
    route: Route,
  },
  {
    path: routes.cmsLeadDashboard,
    element: <CMSLeadDashboard />,
    route: Route,
  },
  {
    path: routes.cmsDealDashboard,
    element: <CMSDealDashboard />,
    route: Route,
  },
  {
    path: routes.leadsDashboard,
    element: <LeadsDasboard />,
    route: Route,
  },
  {
    path: routes.dealsDashboard,
    element: <DealsDashboard />,
    route: Route,
  },
  {
    path: routes.bulkUpload,
    element: <BulkUpload />,
    route: Route,
  },
  {
    path: routes.userCall,
    element: <EmployeeUserCall />,
    route: Route,
  },
  // //Application
  {
    path: routes.chat,
    element: <Chat />,
    route: Route,
  },
  {
    path: routes.activityCalendar,
    element: <ActivityCalendar />,
    route: Route,
  },
  {
    path: routes.moodMeter,
    element: <MoodMeterDashboard />,
    route: Route,
  },
  {
    path: routes.moodQuestions,
    element: <MoodQuestionsPage />,
    route: Route,
  },
  {
    path: routes.moodQuestionnaire,
    element: <MoodQuestionnairePage />,
    route: Route,
  },
  {
    path: routes.superAdminDashboard,
    element: <SuperAdminDashboard />,
    route: Route,
  },
  {
    path: routes.todo,
    element: <TodoPage defaultView="grid" />,
    route: Route,
  },
  {
    path: routes.TodoList,
    element: <TodoPage defaultView="list" />,
    route: Route,
  },
  {
    path: routes.fileManager,
    element: <FileManager />,
    route: Route,
  },
  {
    path: routes.email,
    element: <EmailSelect />,
    route: Route,
  },

  {
    path: routes.accessFile,
    element: <AccesFile />,
    route: Route,
  },
  {
    path: routes.tickets,
    element: <Tickets />,
    route: Route,
  },
  {
    path: routes.ticketsAssigned,
    element: <AssignedTickets />,
    route: Route,
  },
  {
    path: routes.assetStocks,
    element: <AssetsStock />,
  },
  {
    path: routes.assignAssets,
    element: <AssignAsset />,
  },
  {
    path: routes.assetCategories,
    element: <AssetsCategory />,
  },
  {
    path: routes.assetProducts,
    element: <AssetsProduct />,
  },
  {
    path: routes.assetLocations,
    element: <AssetsLocation />,
  },
  {
    path: routes.employeedetails,
    element: <EmployeeDetails />,
    route: Route,
  },
  {
    path: routes.attendancereport,
    element: <AttendanceReport />,
    route: Route,
  },

  {
    path: routes.settings,
    element: <Settings />,
    route: Route,
  },
  {
    path: routes.leavereport,
    element: <LeaveReport />,
    route: Route,
  },
  {
    path: routes.ticketCategories,
    element: <TicketCategory />,
  },
  {
    path: routes.applicationsList,
    element: <CandidateListView />,
    route: Route,
  },
  {
    path: routes.candidateslist,
    element: <CandidateListView />,
    route: Route,
  },
  {
    path: routes.candidatesGrid,
    element: <CandidateGridView />,
    route: Route,
  },
  {
    path: routes.interviewList,
    element: <InterviewList />,
    route: Route,
  },
  {
    path: routes.candidateskanban,
    element: <CandidateKanbanView />,
    route: Route,
  },
  {
    path: routes.candidateDetails,
    element: <CandidateDetails />,
    route: Route,
  },
  {
    path: routes.jobgrid,
    element: <JobGrid />,
    route: Route,
  },
  {
    path: routes.jobDetails,
    element: <JobDetails />,
    route: Route,
  },
  {
    path: routes.refferal,
    element: <RefferalList />,
    route: Route,
  },
  {
    path: routes.referCandidates,
    element: <EmployeeReferrals />,
    route: Route,
  },
  {
    path: routes.hiringSetting,
    element: <HiringSettings />,
    route: Route,
  },
  {
    path: routes.recruitmentCandidatesList,
    element: <RecruitmentCandidatesList />,
    route: Route,
  },
  {
    path: routes.recruitmentCandidateView,
    element: <RecruitmentCandidateView />,
    route: Route,
  },
  {
    path: routes.projectsList,
    element: <ProjectsList />,
    route: Route,
  },
  {
    path: "/projects/:projectKey",
    element: <ProjectShell />,
    route: Route,
    children: [
      {
        index: true,
        element: <ProjectOverview />,
      },
      {
        path: routes.projectBoard,
        element: <BoardPage />,
      },
      {
        path: routes.projectBacklog,
        element: <BacklogPage />,
      },
      {
        path: routes.projectIssues,
        element: <IssuesList />,
      },
      {
        path: routes.projectIssueDetails,
        element: <IssueDetails />,
      },
      {
        path: routes.projectReports,
        element: <ProjectReports />,
      },
      {
        path: routes.projectGantt,
        element: <GanttPage />,
      },
      {
        path: routes.projectSettings,
        element: <DetailsSettings />,
      },
      {
        path: routes.projectSettingsMembers,
        element: <MembersSettings />,
      },
      {
        path: routes.projectSettingsBoard,
        element: <BoardSettings />,
      },
      {
        path: routes.projectSettingsLabels,
        element: <LabelsSettings />,
      },
      {
        path: routes.projectSettingsCustomFields,
        element: <CustomFieldsSettings />,
      },
      {
        path: routes.projectSettingsComponents,
        element: <ComponentsSettings />,
      },
      {
        path: routes.projectSettingsVersions,
        element: <VersionsSettings />,
      },
      {
        path: routes.projectSettingsResolutions,
        element: <ResolutionsSettings />,
      },
    ],
  },
  {
    path: routes.employeeList,
    element: <EmployeeList />,
    route: Route,
  },
  {
    path: routes.employeeGrid,
    element: <EmployeesGrid />,
    route: Route,
  },
  {
    path: routes.departments,
    element: <Department />,
    route: Route,
  },
  {
    path: routes.designations,
    element: <Designations />,
    route: Route,
  },
  {
    path: routes.policy,
    element: <Policy />,
    route: Route,
  },
  {
    path: routes.leaveadmin,
    element: <LeaveAdmin />,
    route: Route,
  },
  {
    path: routes.empLeaveSummaryForAdmin,
    element: <LeaveSummaryPage />,
    route: Route,
  },
  {
    path: routes.leaveemployee,
    element: <LeaveEmployee />,
    route: Route,
  },
  {
    path: routes.leavesettings,
    element: <LeaveSettings />,
    route: Route,
  },
  {
    path: routes.leaveBalanceAuditLog,
    element: <AdjustmentLogPage />,
    route: Route,
  },
  {
    path: routes.attendanceadmin,
    element: <AttendanceAdmin />,
    route: Route,
  },
  {
    path: routes.payrollReport,
    element: <PayrollReportPage />,
    route: Route,
  },
  {
    path: routes.employeeAttendanceLogsForAdmin,
    element: <AttendanceEmployee />,
    route: Route,
  },
  {
    path: routes.holidayUpload,
    element: <HolidayUpload />,
    route: Route,
  },
  {
    path: routes.attendanceemployee,
    element: <AttendanceEmployee />,
    route: Route,
  },
  {
    path: routes.timesheet,
    element: <TimeSheet />,
    route: Route,
  },
  {
    path: routes.scheduletiming,
    element: <ScheduleTiming />,
    route: Route,
  },
  {
    path: routes.overtime,
    element: <OverTime />,
    route: Route,
  },
  //orgination
  {
    path: routes.orginationChart,
    element: <OrganizationChart />,
    route: Route,
  },
  // //crm
  {
    path: routes.contactList,
    element: <ContactList />,
    route: Route,
  },
  {
    path: routes.contactGrid,
    element: <ContactGrid />,
    route: Route,
  },
  {
    path: routes.contactDetails,
    element: <ContactDetails />,
    route: Route,
  },
  {
    path: routes.companiesGrid,
    element: <CompaniesGrid />,
    route: Route,
  },
  {
    path: routes.companiesList,
    element: <CompaniesList />,
    route: Route,
  },
  {
    path: routes.companiesDetails,
    element: <CompaniesDetails />,
    route: Route,
  },
  {
    path: routes.leadsGrid,
    element: <LeadsGrid />,
    route: Route,
  },
  {
    path: routes.facebookLeads,
    element: <FacebookLeadsConfig />,
    route: Route,
  },
  {
    path: routes.whatsAppLeads,
    element: <WhatsAppAccounts />,
    route: Route,
  },
  {
    path: routes.webhookIntegrations,
    element: <WebhookIntegrationsPage />,
    route: Route,
  },
  {
    path: routes.whatsAppLeadsChat,
    element: <WhatsAppChatsViewer />,
    route: Route,
  },
  {
    path: routes.leadsForm,
    element: <LeadsFormList />,
    route: Route,
  },
  {
    path: routes.leadsList,
    element: <LeadsList />,
    route: Route,
  },
  {
    path: routes.leadsTransfer,
    element: <LeadsTransfer />,
    route: Route,
  },
  {
    path: routes.dealsTransfer,
    element: <DealsTransfer />,
    route: Route,
  },
  {
    path: routes.leadsDetails,
    element: <LeadsDetails />,
    route: Route,
  },
  {
    path: routes.dealsGrid,
    element: <DealsGrid />,
    route: Route,
  },
  {
    path: routes.dealsList,
    element: <DealsList />,
    route: Route,
  },
  {
    path: routes.leadsqueue,
    element: <LeadsQueue />,
    route: Route,
  },
  {
    path: routes.leadBank,
    element: <LeadBankPage />,
    route: Route,
  },
  {
    path: routes.leadsInQueueHistory,
    element: <LeadsHistoryPage />,
    route: Route,
  },
  {
    path: routes.dealsDetails,
    element: <DealsDetails />,
    route: Route,
  },
  {
    path: routes.pipeline,
    element: <Pipeline />,
    route: Route,
  },
  {
    path: routes.analytics,
    element: <Analytics />,
    route: Route,
  },
  {
    path: routes.crmSettings,
    element: <CrmSettings />,
    route: Route,
  },
  {
    path: routes.liveCall,
    element: <LiveCalls />,
    route: Route,
  },
  {
    path: routes.leadsCall,
    element: <LeadsCall />,
    route: Route,
  },
  {
    path: routes.callLogs,
    element: <CallLogs />,
    route: Route,
  },

  //Super Admin
  {
    path: routes.superAdminCompanies,
    element: <Companies />,
    route: Route,
  },
  {
    path: routes.superAdminSubscriptions,
    element: <Subscription />,
    route: Route,
  },
  {
    path: routes.superAdminPackages,
    element: <Packages />,
    route: Route,
  },

  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },

  //ERS - Reports
  {
    path: routes.ersReportsOverview,
    element: <MyReports />,
    route: Route,
  },
  {
    path: routes.ersReportsCreate,
    element: <CreateReport />,
    route: Route,
  },
  {
    path: routes.ersReportsEdit,
    element: <EditReport />,
    route: Route,
  },

  // ERS - Team Reports
  {
    path: routes.ersTeamReportsOverview,
    element: <TeamReports />,
    route: Route,
  },

  // ERS - Reports Setting
  {
    path: routes.ersReportsSettingReportType,
    element: <ReportType />,
    route: Route,
  },

  //========================
  // AUTOMATIONS
  //========================
  {
    path: routes.automationCreate,
    element: <AutomationCreate />,
    route: Route,
  },
  {
    path: routes.automationEdit,
    element: <AutomationEdit />,
    route: Route,
  },
  {
    path: routes.automationHistory,
    element: <ExecutionHistory />,
    route: Route,
  },
  {
    path: routes.assetsAutomation,
    element: <AssetsAutomation />,
    route: Route,
  },
  {
    path: routes.leadsAutomation,
    element: <LeadsAutomation />,
    route: Route,
  },
  {
    path: routes.attendanceAutomation,
    element: <AttendanceAutomation />,
    route: Route,
  },
  {
    path: routes.dealsAutomation,
    element: <DealsAutomation />,
    route: Route,
  },
  {
    path: routes.taskManagerAutomation,
    element: <TaskManagerAutomation />,
    route: Route,
  },
  {
    path: routes.calendarAutomation,
    element: <CalendarAutomation />,
    route: Route,
  },
  {
    path: routes.employeeReportingAutomation,
    element: <EmployeeReportingAutomation />,
    route: Route,
  },
  {
    path: routes.ticketsAutomation,
    element: <TicketsAutomation />,
    route: Route,
  },

  //Configuration
  {
    path: routes.configuration,
    element: <Configuration />,
    children: [
      {
        path: routes.fonada, // ✅ becomes /configuration/fonada
        element: <Fonada />,
      },
      {
        index: true,
        element: <WhatsappConfigDetailPage />, // or your component
      },
    ],
    route: Route,
  },

  // Whatsapp configuration: Updated
  {
    path: routes.whatsappConfigurations,
    element: <WhatsappConfig />,
    route: Route,
  },
  {
    path: routes.whatsappTemplates,
    element: <ConfigTemplatesPage />,
    route: Route,
  },
  {
    path: routes.whatsappMessageLogs,
    element: <ConfigTemplateMessageLogsPage />,
    route: Route,
  },
  {
    path: routes.emailTemplates,
    element: <EmailTemplatesPage />,
    route: Route,
  },
  {
    path: routes.emailTemplateCreate,
    element: <EmailTemplateEditorPage />,
    route: Route,
  },
  {
    path: routes.emailTemplateEdit,
    element: <EmailTemplateEditorPage />,
    route: Route,
  },
  {
    path: routes.emailTemplateVersions,
    element: <EmailTemplateEditorPage />,
    route: Route,
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
  },
  {
    path: routes.candidatesRequestForm,
    element: <CandidateListView />, // Placeholder
    route: Route,
  },
  {
    path: routes.thankYou,
    element: <ThankYouPage />,
    route: Route,
  },
  {
    path: routes.publicLeadForm,
    element: <PublicLeadForm />,
    route: Route,
  },
  {
    path: routes.careerPagePublic,
    element: <CareerPage />,
    route: Route,
  },
  {
    path: routes.careerJobDetailsPublic,
    element: <JobDetailsApply />,
    route: Route,
  },
  {
    path: routes.applicationTracking,
    element: <ApplicationTracking />,
    route: Route,
  },
  {
    path: routes.candidateDashboard,
    element: <CandidateDashboard />,
    route: Route,
  },
  {
    path: routes.publicFeedback,
    element: <PublicFeedbackForm />,
    route: Route,
  },
  {
    path: routes.publicScheduling,
    element: <PublicSelfScheduling />,
    route: Route,
  },
  {
    path: routes.candidateUploadPortal,
    element: <CandidateUploadPortal />,
    route: Route,
  },
];
